import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import Layout from './components/Layout';
import BookingHome from './components/BookingHome';
import MyBookings from './components/MyBookings';
import MyProfile from './components/MyProfile';
import ManageUsers from './components/ManageUsers';
import FloorLayoutEditor from './components/FloorLayoutEditor';
import BookingReport from './components/BookingReport';
import PublicFloorPlan from './components/PublicFloorPlan';
import Settings from './components/Settings';
import ManageHolidays from './components/ManageHolidays';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#052e2b',
    },
    secondary: {
      main: '#68DA6A',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/live" element={<PublicFloorPlan />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route path="/" element={<BookingHome />} />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/profile" element={<MyProfile />} />
              <Route
                path="/manage-users"
                element={
                  <PrivateRoute adminOnly>
                    <ManageUsers />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report"
                element={
                  <PrivateRoute reportAccess>
                    <BookingReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/floor-layout"
                element={
                  <PrivateRoute adminOnly>
                    <FloorLayoutEditor />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute adminOnly>
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/holidays"
                element={
                  <PrivateRoute adminOnly>
                    <ManageHolidays />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
